module.exports = __webpack_public_path__ + "img/0ce71a6.png";